export default "__VITE_ASSET__7bef342a__"